import Alert from '@lendi-ui/alert';
import { mb } from '@lendi-ui/spacing';
import { Link } from '@lendi-ui/typography';
import * as React from 'react';
import styled from 'styled-components';
import { LALAAuthError, LALAAuthFlow } from '../../state/state';
import { Brand, useSession } from '@lendi/lala-react';

export interface AlertErrorProps {
  error?: LALAAuthError;
}

const renderDescription = (description?: string, brand?: Brand) => {
  if (!description) return null;

  const contactUsRegex = /contact us/gi;
  const parts = description.split(contactUsRegex);

  return parts.map((part, index) => (
    <>
      {part}
      {index < parts.length - 1 && (
        <Link data-testid="contactUs" href={brand === Brand.Aussie ? '/get-in-touch' : '/contactus'} color="error.500">
          contact us
        </Link>
      )}
    </>
  ));
};

export const AlertError: React.FC<AlertErrorProps> = ({ error }) => {
  const { brand } = useSession();

  return error && error.flow === LALAAuthFlow.Passwordless ? (
    <AlertWrapper
      data-testid="errorMessage"
      variant={error?.authError.errorLevel || 'error'}
      heading={error?.authError.alertHeading || ''}
    >
      {renderDescription(error?.authError?.description, brand)}
    </AlertWrapper>
  ) : (
    <></>
  );
};

export const AlertErrorSsi: React.FC<AlertErrorProps> = ({ error }) => {
  const { brand } = useSession();

  return error && error.flow === LALAAuthFlow.SSI ? (
    <AlertWrapper data-testid="errorMessage" variant="error">
      {renderDescription(error?.authError?.description, brand)}
    </AlertWrapper>
  ) : (
    <></>
  );
};

export const AlertWrapper = styled(Alert)`
  ${mb('sm')}
`;
